import FManApi from "../fmanlibs/FManApi";
import LoginButton from "../libs/login/LoginButton";

export default function Header(){
    return <header className="flex middle gap-8">
        <div className="logo"/>
        <b>File Manager</b>
        <div className="flex1"/>
        <LoginButton api={FManApi.i}/>
    </header>
}